import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './metodos/AuthContext'; // ajusta la ruta si es necesario

window.addEventListener("wheel", () => {
  if (document.activeElement.type === "number") {
    document.activeElement.blur();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <AuthProvider> {/* ✅ Envolviendo toda tu app */}
      <App />
    </AuthProvider>
  //</React.StrictMode>
);

reportWebVitals();
